import React from 'react';
import { Box, Fade, Backdrop } from '@mui/material';
import { styled } from '@mui/material/styles';
import Lottie from 'lottie-react';
import chattyLottie from '../../assets/lottie/chatty.json';

// Styled backdrop with glassmorphism
const GlassmorphicBackdrop = styled(Backdrop)(({ theme }) => ({
  position: 'absolute',
  background: 'rgba(255, 255, 255, 0.75)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ModernLoadingOverlay = ({ 
  open = false, 
  text = 'Loading...', 
  showProgressDots = true,
  size = 60,
  thickness = 4 
}) => {
  return (
    <Fade in={open} timeout={300}>
      <GlassmorphicBackdrop className="glassmorphic-loading-backdrop" open={open}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Lottie 
            animationData={chattyLottie} 
            loop={true} 
            style={{ width: 140, height: 140 }} 
          />
        </Box>
      </GlassmorphicBackdrop>
    </Fade>
  );
};

export default ModernLoadingOverlay;
